import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
export const FlavorFinderContext = createContext(undefined);
export const useFlavorFinderContext = () => useContext(FlavorFinderContext);
export const FlavorFinderContextProvider = ({ children, data }) => {
    const [previousStep, setPreviousStep] = useState([-1]);
    const [nextStep, setNextStep] = useState(0);
    const [activeStep, setActiveStep] = useState(-1);
    const [answers, setAnswers] = useState([]);
    const [selectedAnswersPayload, setSelectedAnswersPayload] = useState([]);
    const [userJourney, setUserJourney] = useState([{ view: "intro" }]);
    const [currentView, setCurrentView] = useState("intro");
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(-1);
    const flavorFinderData = data;
    const [quizResult, setQuizResult] = useState({
        resultsLink: "",
        results: [],
        headerUrl: "",
        resultsLinkWithDevice: "",
    });
    const startQuiz = () => {
        const firstQuestion = flavorFinderData.quizTransitions.find((question) => !question.onAnswerId);
        if (firstQuestion) {
            setCurrentQuestion(firstQuestion);
            setUserJourney([...userJourney, { view: "question", question: firstQuestion }]);
            setCurrentQuestionIndex(0);
            setCurrentView("question");
        }
        else {
            console.error("Couldn't find the first question!");
        }
    };
    const resetQuiz = () => {
        setCurrentQuestion(null);
        setUserJourney([{ view: "intro" }]);
        setCurrentQuestionIndex(0);
        setCurrentView("intro");
    };
    const handlePreviousStepClick = useCallback(() => {
        const updatedJourney = [...userJourney];
        updatedJourney.pop();
        setUserJourney(updatedJourney);
        setCurrentQuestionIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
        const lastStep = updatedJourney[updatedJourney.length - 1];
        if (lastStep) {
            setCurrentView(lastStep.view);
            if (lastStep.view === "question" && lastStep.question) {
                setCurrentQuestion(lastStep.question);
            }
        }
    }, [setCurrentQuestion, setCurrentQuestionIndex, setCurrentView, setUserJourney, userJourney]);
    const questions = flavorFinderData.quizTransitions;
    const value = useMemo(() => ({
        activeStep,
        setActiveStep,
        nextStep,
        setNextStep,
        previousStep,
        setPreviousStep,
        answers,
        setAnswers,
        questions,
        selectedAnswersPayload,
        setSelectedAnswersPayload,
        userJourney,
        setUserJourney,
        currentView,
        setCurrentView,
        flavorFinderData,
        startQuiz,
        resetQuiz,
        currentQuestion,
        setCurrentQuestion,
        currentQuestionIndex,
        setCurrentQuestionIndex,
        quizResult,
        setQuizResult,
        handlePreviousStepClick,
    }), [
        activeStep,
        answers,
        currentQuestion,
        currentQuestionIndex,
        currentView,
        flavorFinderData,
        handlePreviousStepClick,
        nextStep,
        previousStep,
        questions,
        quizResult,
        selectedAnswersPayload,
        startQuiz,
        userJourney,
    ]);
    return _jsx(FlavorFinderContext.Provider, { value: value, children: children });
};
//# sourceMappingURL=FlavorFinderContextProvider.js.map